export default "__VITE_ASSET__ccddd5c9__"